import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/7a5b040bfff3a0cfc0bcd3a8224a4496/cf4746026331f44995b29c96035e302f.jpeg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            一站式粵港外勞招聘服務
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            萬業人才資本持有香港職業介紹所牌照，超過十年經驗，為您提供專業、可靠的外勞招聘解決方案
          </p>
          <div className="flex justify-center">
            <Button size="lg" className="text-lg px-8 py-4" href="https://wa.me/85293663961">
              <i className="ri-whatsapp-line mr-2"></i>
              立即WhatsApp查詢
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};
